import { z } from 'zod'

import { OpenEndedFormat } from '@/app/module/campaigns/types/common'
import ZAction from '@/app/module/campaigns/types/schemas/actions/all-actions'

export const ZAnswerCategory = z.object({
  category: z.string(),
  actions: z.array(ZAction).optional(),
})

const ZOpenEnded = z.object({
  actions: z.array(ZAction).optional(),
  categories: z.array(ZAnswerCategory).optional(),
  format: z.nativeEnum(OpenEndedFormat).optional(),
  formatOption: z.string().optional(),
  regexp: z.string().optional(),
})

export default ZOpenEnded
